  
<!--雷达影像-->
<template>
  <div class="leidaa">
        <iframe src="http://113.247.231.116/qxjdata/radar.html" :width="width+'px'" :height="height+'px'" ></iframe>
  </div>
</template>
<script>
import $ from "jquery";
let moment = require("moment");
export default {
  name: "leidaa",
  data() {
    return {
      height:0,
      width:0,
    };
  },
 
  methods: {
  },
  mounted() {
    // $(".leidaa").height(window.innerHeight-140-35-20);
    $(".leidaa").height(window.innerHeight);
    var w=$(".leidaa").width();
    this.height=$(".leidaa").height()-2;
    this.width=w;
    // this.getWeatherInfo();
  }
};
</script>
<style scoped lang='less'>
 .leidaa{
   
   width:100%;
    
 }
</style>
 


// WEBPACK FOOTER //
// src/components/mobile/leida.vue